import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import videocamera from '@/images/Videocamera.svg';
import { BaseBadge } from './BaseBadge';

interface Props {
    testId?: string;
    className?: string;
    duration?: number;
    isDraft?: boolean;
    isGenerating?: boolean;
}

export const VideoBadge = ({ testId = 'video-tile-badge', duration, isDraft, isGenerating, className }: Props) => {
    const videoDuration = duration && new Date(Math.max(duration, 1) * 1000).toISOString().substring(14, 19);

    if (isGenerating) {
        return null;
    }

    return (
        <BaseBadge data-testid={testId} isDraft={!!isDraft} className={className}>
            {isDraft ? (
                'Draft'
            ) : (
                <>
                    <MaskedIcon src={videocamera} size="14px" />
                    {videoDuration}
                </>
            )}
        </BaseBadge>
    );
};
